import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import PharmaciesService from 'shared/services/PharmaciesService';
import {
  getAvailablePharmacies,
  getAvailablePharmaciesFail,
  setAvailablePharmacies,
  setAvailablePharmaciesLoading,
  setPharmacy as setPharmacyAction
} from './pharmacies.redux';
import { TAction } from 'shared/types';
import {
  IExternalPharmacy,
  IResponseSetExternalPharmacy,
  ISearchAvailablePharmacies,
  ISetPharmacy
} from 'shared/interfaces/pharmacy.interface';
import { setExternalPharmacy } from 'store/orders/orders.redux';
import { openNotificationMessage } from 'shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';

function* getAvailablePharmaciesSaga({
  payload
}: TAction<ISearchAvailablePharmacies>) {
  try {
    yield put(setAvailablePharmaciesLoading());
    const result: AxiosResponse<IExternalPharmacy[]> = yield call(
      PharmaciesService.getAvailablePharmacies,
      payload
    );

    yield put(setAvailablePharmacies(result));
  } catch (error) {
    console.log('error', error);
    yield put(getAvailablePharmaciesFail());
  }
}

function* setPharmacy({ payload }: TAction<ISetPharmacy>) {
  try {
    if (payload) {
      const result: AxiosResponse<IResponseSetExternalPharmacy> = yield call(
        PharmaciesService.setPharmacy,
        payload
      );
      yield put(setExternalPharmacy(result));
      yield openNotificationMessage({
        type: NotificationMessages.Success,
        title: 'Success',
        message: 'Pharmacy added successfully.'
      });
    }
  } catch (error) {
    console.log('setPharmacy error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message: 'The pharmacy adding was unsuccessful.'
    });
  }
}

function* Pharmacies() {
  yield takeLatest(getAvailablePharmacies.type, getAvailablePharmaciesSaga);
  yield takeLatest(setPharmacyAction.type, setPharmacy);
}

export default Pharmacies;
